<template>
  <v-app>
    <v-dialog v-model="dialog" max-width="400px">      
      <v-card>
        <v-card-title v-if="infos.title" style="display:block;" class="styled-header">
          <span class="headline" v-html="infos.title"></span>
        </v-card-title>
        <v-card-text>
          <p v-html="infos.text"></p>  
         <!-- <a class="btn block" appEvent="true"  appEventCategory="pop-up" @appEventLabel="infos.eventLabel" @click="data.onClose()">{{infos.btn}}</a>-->
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>

import ModalCartaoDesassociado from '@/components/ModalCartaoDesassociado.vue'

import {VDialog,VCard,VCardTitle,VCardText,VApp} from 'vuetify/lib'

export default {
  name: 'ModalGenerico',
  methods: {
  },
  components: {
      VDialog,
      VCard,
      VCardTitle,
      VCardText,
      VApp,
    ModalCartaoDesassociado
  },
  props: {
      infos: null,
      show: false,
  },
  watch: { 
    show: {
      handler: function (newVal) {
        this.dialog = newVal || false;
      },
      deep: true
    },
    dialog: {
      handler: function (newVal) {
          console.log(newVal);
          if(newVal == false && this.infos.onClose) this.infos.onClose();
      },
      deep: true
    }
  },
  created() {
    this.dialog = this.show;
  },
  data() {
    return {
        dialog: false,
    }
  }
}
</script>

<style lang="scss">

</style>
